import React, { Component } from 'react';

class KeyConsiderationsStep extends Component {
	render() {
		const { data, onChange } = this.props;

		return (
			<div className="rfp-step-content">
				<h1 className="rfp-step-title">Key Considerations</h1>

				{/* Decision Factors */}
				<div className="rfp-field-group">
					<label className="rfp-field-label">Decision Factors</label>
					<textarea
						className="rfp-textarea"
						value={data.decisionFactors || ''}
						onChange={(e) => onChange('decisionFactors', e.target.value)}
						placeholder="Please list any must-haves, deal breakers, or special requirements. As well as factors will influence the final hotel/venue selection? (e.g., price, location, availability, brand, amenities, proximity to airport)"
						rows={4}
					/>
				</div>

				{/* History & Reservations */}
				<h1 className="rfp-step-title rfp-section-title">History &amp; Reservations</h1>

				{/* Event History */}
				<div className="rfp-field-group">
					<label className="rfp-field-label">Event History</label>
					<textarea
						className="rfp-textarea"
						value={data.eventHistory || ''}
						onChange={(e) => onChange('eventHistory', e.target.value)}
						placeholder="Previous venues, years hosted, attendance trends, any relevant event history."
						rows={4}
					/>
				</div>

				{/* Reservations / Booking Notes */}
				<div className="rfp-field-group">
					<label className="rfp-field-label">Reservations / Booking Notes / Payment Details</label>
					<textarea
						className="rfp-textarea"
						value={data.reservationNotes || ''}
						onChange={(e) => onChange('reservationNotes', e.target.value)}
						placeholder="Current reservations or holds, housing bureau information, reservation method preferences, payment details."
						rows={4}
					/>
				</div>
			</div>
		);
	}
}

export default KeyConsiderationsStep;
